import React from 'react'
import StarRatings from 'react-star-ratings'
import Box from "@material-ui/core/Box";

const style = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
}

const button_style = {
  fontFamily:"Open Sans Hebrew", 
  fontSize: "20px",
  border: "none",
  background: "#65AC45",
  borderRadius: "4px",
  color: "#FFFFFF",
  padding: "6px 48px",
  textAlign: "center",
  textDecoration: "none"

}


class Rating extends React.Component {  
  constructor(props) {
    super(props);
    this.state = {
      rating: 0
    };
  }

  changeRating = (newRating) => {
    this.setState({rating: newRating});
  }

  handleSend = () => {
    var url = 'mailto:';
    url += "bbmeyuchad@gmail.com";
    url += "?subject= משוב על הבייביסיטר המיוחד"
    url += this.props.babysitter["full_name"];
    url += " ";
    url += "(";
    url += this.props.babysitter["email"];
    url += ")";
    url += " ";
    url += "&body= שלום, ברצוני לתת לבייביסיטר המיוחד ";
    //name?
    url += this.props.babysitter["full_name"];
    url += " ";
    url += "את הדירוג: ";
    url += this.state.rating;
    url += ". ";
    url += "פירוט: ";
    window.location.assign(url);
  }

  render() {
    return (
      <div style={style}>
        <StarRatings
          rating={this.state.rating}
          starRatedColor="#F2C94C"
          starHoverColor="#F2C94C"
          changeRating={this.changeRating}
          numberOfStars={5}
          name='rating'
          starDimension="34px"
          starSpacing="-2px"
        />
        <Box m={1}/>
        <button style={button_style} onClick={this.handleSend}> שליחה </button>
      </div>
    );
  }
}

export default Rating;